import { toast } from "react-toastify";
import { httpPost } from "../../HttpRequestHandling/httpRequestHandler";

export const handleTestConnection = async (
    payload = null,
    updateState = () => { },
    inProgress = () => { }
) => {
    inProgress?.(true);
    try {
        // validate each field individually
        if ((payload.adTechIntegrationId || 0) <= 0) {
            if (!payload.adToolId) {
                toast.error("Select an Integration");
                return;
            }
            if (!payload.accountId) {
                toast.error("Account ID is required.");
                return;
            }
            if (!payload.userId) {
                toast.error("User ID is required.");
                return;
            }
            if (!payload.password) {
                toast.error("Password is required.");
                return;
            }
            
            if (!payload.accessTag) {
                toast.error("Access Tag is required.");
                return;
            }
            
        }
       

        // ensure DevToken is optional
        const finalPayload = {
            ...payload,
            IpcDevToken: payload.IpcDevToken ?? ""
        };

        const resp = await httpPost('/api/integrations/TestConnection', finalPayload);
        const ok = resp?.data === true || resp === true;
        if (ok) {
            toast.success("Connection verified successfully.");
            updateState(true);
        } else {
            toast.error("Connection failed.");
            updateState(false);
        }
    } catch (err) {
        toast.error("Connection failed.");
        updateState(false);
    } finally {
        inProgress?.(false);
    }
};